const idadeMaximaPermitidaFilhos = 30;

export const qtdDependentesMaiorIgual65anos = dependentes => {
    const qtdDependentes = dependentes.filter(({ Idade }) => Idade >= 65).length;
    const quantidadeMaximaDeDependentesMaiorIgual65Permitidas = 2;

    return qtdDependentes === quantidadeMaximaDeDependentesMaiorIgual65Permitidas;
};

const parentescosPermitidosEstrutura1 = ['01', '02', '5', '10', '15', '32', '50', '20007', '20008'];

const parentescos = {
    '01': 'PAI',
    '20008': 'PADRASTO',
    '02': 'MAE',
    '20007': 'MADRASTA',
    '10': 'ESPOSO(A)',
    '32': 'EX-CONJUGE',
    '15': 'SOGRO(A)',
    '5': 'FILHO(A)',
    '50': 'FILHO(A) ADOTIVO'
};

export const grausEquivalentes = {
    '01': '20008',
    '20008': '01',

    '02': '20007',
    '20007': '02',

    '10': '32',
    '32': '10'
};

export const estaDentroDaEstrutura1 = valores => {
    const { Parentesco, Idade } = valores;
    const parentescoPermitido = parentescosPermitidosEstrutura1.includes(Parentesco.trim());

    if ((Parentesco.trim() === '50' || Parentesco.trim() === '5') && Idade > idadeMaximaPermitidaFilhos) {
        return false;
    }

    return parentescoPermitido;
};

export const validaDependentesEstrutura1 = (dependentes, values) => {
    if (values.Seq) {
        return false;
    }

    const possuiDependentesForaDaEstrutura1 = dependentes.find(dependente => {
        const Parentesco = dependente['GrauParentesco.Grau'];
        const Idade = dependente.Idade;

        const values = {
            Parentesco,
            Idade
        };

        return !estaDentroDaEstrutura1(values);
    });

    return possuiDependentesForaDaEstrutura1 ? true : false;
};

const quantidadeMaximaPermitidaDeDependentes = 10;

const verificaEstaEditando = values => values.Nome ? true : false;

export const validatorMaiorIgual65Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [

        verificarIdadePreenchida(valoresForm.Idade),
        idadeAte65(valoresForm.Idade),
        qtdDependentesMaiorIgual65anos(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const calcularQuantidadeDependentes65anosEdicao = (dependentes, idadeAssociado, valoresForm, edicao) => {
    const resultado = dependentes.reduce((acc, dep) => {
        if (dep.Idade >= 65) {
            acc.qtdDependentes65ouMais += 1;
        }

        if (edicao && dep.Seq === valoresForm.Seq) {
            acc.idadeEditada = valoresForm.Idade;
            acc.dependenteEditado = dep;
        }

        return acc;
    }, {
        qtdDependentes65ouMais: 0,
        idadeEditada: null,
        dependenteEditado: null
    });

    if (idadeAssociado >= 65) {
        resultado.qtdDependentes65ouMais += 1;
    }

    if (edicao && resultado.idadeEditada < 65) {
        resultado.qtdDependentes65ouMais -= 1;
    }

    return resultado.qtdDependentes65ouMais > 2;
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values) => {
    const seq = values.Seq;
    const parentesco = values.Parentesco;

    if (!parentesco) {
        return false;
    }

    if (parentesco.trim() === '5' || parentesco.trim() === '50') {
        return false;
    }

    const possuiParentescoSelecionado = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if (!possuiParentescoSelecionado.length) {
        const grausEquivalente = grausEquivalentes[`${parentesco.trim()}`];

        const possuiParentescoEquivalente = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === grausEquivalente);

        return possuiParentescoEquivalente.length ? seq ? seq !== possuiParentescoEquivalente[0].Seq : true : false;
    }

    if (parentesco.trim() === '15') {
        return possuiParentescoSelecionado.length === 2;
    }

    if (seq) {
        return seq !== possuiParentescoSelecionado[0].Seq;
    }

    return true;
};

export const validatorEstrtutura1 = valoresForm => {
    const arrayDeValidacoes = [

        !estaDentroDaEstrutura1(valoresForm)

    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPossui10Dependentes = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        qtdDependentes(dependentes),
        verificaEstaEditando(valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescoEmDuplicidade = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificarIdadePreenchida = idade => idade !== '' && idade !== null;
const idadeAte65 = idade => idade >= 65;
const qtdDependentes = dependentes => dependentes.length === quantidadeMaximaPermitidaDeDependentes;

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();
    const grauEquivalente = grausEquivalentes[parentesco];

    if (parentesco === '15') {
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]} / ${parentescos[`${grauEquivalente}`]}`;
};

let quantidadeDepAcima65Anos = 0;
let sequenciaIdentificadorDep = [];
let associadoAcima65 = false;

export const calcularQuantidadeDependentes65anos = (dependentes, idadeAssociado) => {
    const resultado = dependentes.reduce((acc, dep) => {
        if (dep.Idade >= 65) {
            acc.qtdDependentes += 1;
            acc.sequencias.push(dep.Seq);
        }

        return acc;
    }, {
        qtdDependentes: 0,
        sequencias: []
    });

    if (idadeAssociado >= 65) {
        resultado.qtdDependentes += 1;
        associadoAcima65 = true;
    }

    quantidadeDepAcima65Anos = resultado.qtdDependentes;
    sequenciaIdentificadorDep = resultado.sequencias;

    return resultado.qtdDependentes > 2;
};

export const comparaRegrasDepAtuaisComDepUpSell = (dependentes, subGrupoSelecionadoUpSell, idadeAssociado) => {
    try {
        if (dependentes.length > quantidadeMaximaPermitidaDeDependentes) {
            return `No ZELO IDEAL SAF é permite ${quantidadeMaximaPermitidaDeDependentes} dependentes. Por favor, remova os dependentes excedentes para continuar`;
        }

        if (calcularQuantidadeDependentes65anos(dependentes, idadeAssociado)) {
            let msg = `No ZELO IDEAL SAF é permite duas pessoas com mais de 65 anos entre o titular do plano e dependentes. Existem: ${quantidadeDepAcima65Anos}`;

            if (associadoAcima65) {
                msg += ', incluindo o titular do plano.';
            } else {
                msg += `, todos entre os dependentes com o Seq: ${sequenciaIdentificadorDep.join(', ')} estão acima desta idade.`;
            }

            return msg;
        }

        for (const dep of dependentes) {
            const parentesco = dep['GrauParentesco.Grau'].trim();
            const categoria = dep.Categoria;
            const idade = dep.Idade;

            const mensagensErro = {
                categoriaNaoPermitida: `O dependente com a sequência ${dep.Seq} 
                    possui uma categoria inválida (${categoria}) para o plano ${subGrupoSelecionadoUpSell}. Por favor, edite ou remova o dependente para continuar.`,
                parentescoNaoPermitido: `O dependente com a Seq: ${dep.Seq} possui um tipo de parentesco que não é permitido para este plano. 
                    Verifique e ajuste o tipo de parentesco para continuar.`,
                parentescoFilhosAcima30anos: `O dependente com a Seq: ${dep.Seq} possui filho(s) a cima de 30 anos, ajuste o dependente para continuar. `
            };

            if (!parentescosPermitidosEstrutura1.includes(parentesco?.trim())) {
                return mensagensErro.parentescoNaoPermitido;
            }

            const categoriasPermitidas = ['ZELO', 'ZPETL'];
            const tipoparentescoComAte30anos = ['5', '50'];

            if (!categoriasPermitidas.includes(categoria?.trim())) {
                return mensagensErro.categoriaNaoPermitida;
            }

            if (tipoparentescoComAte30anos.includes(parentesco) && idade > idadeMaximaPermitidaFilhos) {
                return mensagensErro.parentescoFilhosAcima30anos;
            }
        }
    } catch (error) {
        console.error(error);
    }
};
